


import ImageHeader from "@/components/core/ImageHeader";
import PackageCard from "@/components/PackageCard";
import tableLoading from "@/components/tableLoading";
import NoContent from "@/components/customer-content/NoContent";
export default {
  scrollToTop: true,
  components: {
    tableLoading,
    NoContent,
    PackageCard,
    ImageHeader
  },
  head() {
    return {
      title: this.title,
      meta: [{
        hid: "description",
        name: "description",
        content: this.description,
      },
      {
        hid: "keywords",
        name: "keywords",
        content: "Goa Tour Packages, goa holiday packages, goa tour packages for couple, goa tour packages under 5000, family goa tour packages, goa tour packages price, goa tour packages for family, goa tour packages from bangalore, goa tour packages from pune",
      },
      {
        hid: "og:title",
        property: "og:title",
        content: this.title,
      },
      {
        hid: "og:description",
        property: "og:description",
        content: this.description,
      },
      {
        hid: "twitter:title",
        property: "twitter:title",
        content: this.title,
      },
      {
        hid: "twitter:description",
        property: "twitter:description",
        content: this.description,
      },
      { hid: 'og:image:alt',
        property: 'og:image:alt',
        content: this.title ? this.title : 'Goa App'
      },
      { hid: 'og:image',
        property: 'og:image',
        content: this.$config.siteUrl + '/img/meta-imgs/packages-meta-image.webp'
      },
      { hid: 'image',
        property: 'image',
        content: this.$config.siteUrl + '/img/meta-imgs/packages-meta-image.webp'
      },
      { hid: 'twitter-image',
        property: 'twitter:image',
        content: this.$config.siteUrl + '/img/meta-imgs/packages-meta-image.webp'
      },
      ],
    };
  },
  data() {
    return {
      title: "Goa Tour Packages Starting @ ₹ 3999 - 𝐁𝐨𝐨𝐤 𝐍𝐨𝐰!",
      description: "Goa Tour Packages, goa holiday packages, goa tour packages for couple, goa tour packages under 5000, family goa tour packages, goa tour packages price, goa tour packages for family, goa tour packages from bangalore, goa tour packages from pune",
      selectedValue: null,
      search: "",
      isSearchClicked: false,
      packages: null,
      featuredPackages: null,
      packagesCategories: null,
      listingLoading: true,
      packagesLoading: true,
      categoriesLoading: true,

      eventCategoryModal: false,
    };
  },
  jsonld() {
    return {
      '@context': 'https://schema.org',
      "@type": "Article",
      "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": "https://goa.app/packages"
      },
      "headline": 'Goa Tour Packages - Goa holiday packages for couple',
      "name": 'Goa Tour Packages',
      "url": "https://goa.app/packages",
      "description": "Goa Tour Packages, goa holiday packages, goa tour packages for couple, goa tour packages under 5000, family goa tour packages, goa tour packages price, goa tour packages for family, goa tour packages from bangalore, goa tour packages from pune",
      "image": 'https://goa.app/img/meta-imgs/packages-meta-image.webp',
      "author": {
        "@type": "Person",
        "name": "Sanjeet Kamat"
      },
      "publisher": {
        "@type": "Organization",
        "name": "Goa App",
        "logo": {
          "@type": "ImageObject",
          "url": "https://goa.app/goa-app-logo.svg"
        }
        },
      "genre": 'Tour Package',
      "keywords": "Goa Tour Packages, goa holiday packages, goa tour packages for couple, goa tour packages under 5000, family goa tour packages, goa tour packages price, goa tour packages for family, goa tour packages from bangalore, goa tour packages from pune", 
      "datePublished": "2024-09-08",
      "dateCreated": "2024-09-08",
      "dateModified": "2024-09-08",
      "description": "Goa Tour Packages, goa holiday packages, goa tour packages for couple, goa tour packages under 5000, family goa tour packages, goa tour packages price, goa tour packages for family, goa tour packages from bangalore, goa tour packages from pune",
      "articleBody": "Goa Tour Packages, goa holiday packages, goa tour packages for couple, goa tour packages under 5000, family goa tour packages, goa tour packages price, goa tour packages for family, goa tour packages from bangalore, goa tour packages from pune",
    };
  },
  fetchOnServer: false,
  async fetch() {

//call the api to get featured coupons
this.packages = await fetch(this.$config.fetchUrl + '/api/posts/app/getAllPackages').then(res => res
  .text());
  this.packages = this.getCryptKey(this.packages);
  this.packagesLoading = false;
  //call the api to get featured coupons
this.featuredPackages = await fetch(this.$config.fetchUrl + '/api/posts/app/getFeaturedPackages').then(res => res
  .text());
  this.featuredPackages = this.getCryptKey(this.featuredPackages);
  this.listingLoading = false;
    //call the api to getcategory packages
this.packagesCategories = await fetch(this.$config.fetchUrl + '/api/posts/app/getCategoriesForPackagePageWithSlug').then(res => res
  .text());
  this.packagesCategories = this.getCryptKey(this.packagesCategories);
  this.categoriesLoading = false;
},

methods:{
  activitiesImage(image) {
      if (image.length > 0) {
        return image[0];
      } else {
        return '';
      }
    },
    categoryBtnClicked(item) {
      if (item) {
        this.$router.push({
          path: item
        })
      }
    },
}

};

